/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf } from './GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf';
import {
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOfFromJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOfFromJSONTyped,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOfToJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOfToJSONTyped,
} from './GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf';
import type { GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1 } from './GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1';
import {
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1FromJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1FromJSONTyped,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1ToJSON,
    GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1ToJSONTyped,
} from './GetCustomerPromotions200ResponseCustomerPromotionsInnerAnyOf1';

/**
 * 
 * @export
 * @interface GetCustomerPromotions200ResponseCustomerPromotionsInner
 */
export interface GetCustomerPromotions200ResponseCustomerPromotionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    pointsExpense?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    discountType: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    discountAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    accumulated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    availableInShop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    maxRedemptions?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    minExpense?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    oncePerPerson?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    internalDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    showPopup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    availableInPos?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    availableInAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    pickupType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    freeDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    deleted?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    products?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    customers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    customerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    locations?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    weekdays?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerPromotionsInner
     */
    organizationId: string;
}

/**
 * Check if a given object implements the GetCustomerPromotions200ResponseCustomerPromotionsInner interface.
 */
export function instanceOfGetCustomerPromotions200ResponseCustomerPromotionsInner(value: object): value is GetCustomerPromotions200ResponseCustomerPromotionsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('discountAmount' in value) || value['discountAmount'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSON(json: any): GetCustomerPromotions200ResponseCustomerPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerPromotionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200ResponseCustomerPromotionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'pointsExpense': json['pointsExpense'] == null ? undefined : json['pointsExpense'],
        'discountType': json['discountType'],
        'discountAmount': json['discountAmount'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'accumulated': json['accumulated'] == null ? undefined : json['accumulated'],
        'availableInShop': json['availableInShop'] == null ? undefined : json['availableInShop'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxRedemptions': json['maxRedemptions'] == null ? undefined : json['maxRedemptions'],
        'minExpense': json['minExpense'] == null ? undefined : json['minExpense'],
        'oncePerPerson': json['oncePerPerson'] == null ? undefined : json['oncePerPerson'],
        'internalDescription': json['internalDescription'] == null ? undefined : json['internalDescription'],
        'showPopup': json['showPopup'] == null ? undefined : json['showPopup'],
        'availableInPos': json['availableInPos'] == null ? undefined : json['availableInPos'],
        'availableInAdmin': json['availableInAdmin'] == null ? undefined : json['availableInAdmin'],
        'pickupType': json['pickupType'] == null ? undefined : json['pickupType'],
        'freeDelivery': json['freeDelivery'] == null ? undefined : json['freeDelivery'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'products': json['products'] == null ? undefined : json['products'],
        'customers': json['customers'] == null ? undefined : json['customers'],
        'customerIds': json['customerIds'] == null ? undefined : json['customerIds'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'weekdays': json['weekdays'] == null ? undefined : json['weekdays'],
        'externalId': json['externalId'],
        'organizationId': json['organizationId'],
    };
}

export function GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSON(json: any): GetCustomerPromotions200ResponseCustomerPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerPromotionsInnerToJSONTyped(value?: GetCustomerPromotions200ResponseCustomerPromotionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'pointsExpense': value['pointsExpense'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'accumulated': value['accumulated'],
        'availableInShop': value['availableInShop'],
        'code': value['code'],
        'maxRedemptions': value['maxRedemptions'],
        'minExpense': value['minExpense'],
        'oncePerPerson': value['oncePerPerson'],
        'internalDescription': value['internalDescription'],
        'showPopup': value['showPopup'],
        'availableInPos': value['availableInPos'],
        'availableInAdmin': value['availableInAdmin'],
        'pickupType': value['pickupType'],
        'freeDelivery': value['freeDelivery'],
        'deleted': value['deleted'],
        'categories': value['categories'],
        'products': value['products'],
        'customers': value['customers'],
        'customerIds': value['customerIds'],
        'locations': value['locations'],
        'weekdays': value['weekdays'],
        'externalId': value['externalId'],
        'organizationId': value['organizationId'],
    };
}

